import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import * as Sentry from '@sentry/react';

const UNDEFINED_REJECTION_MESSAGE = 'Unhandled promise rejection with undefined reason';

const normalizeUnhandledRejectionEvent = (event, hint) => {
  const originalException = hint?.originalException;

  if (
    event.exception?.values?.[0]?.type === 'UnhandledRejection'
    && (originalException === undefined || !(originalException instanceof Error))
  ) {
    const message = originalException === undefined
      ? UNDEFINED_REJECTION_MESSAGE
      : `Unhandled promise rejection: ${String(originalException)}`;

    event.exception.values[0].type = 'Error';
    event.exception.values[0].value = message;
  }

  return event;
};

// Initialize Sentry at the top level
Sentry.init({
  dsn: "https://b7895fe43f21fa3a0b494b9dd421d71e@o4508694212378624.ingest.us.sentry.io/4508694214279168",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['https://sso.nylservices.net', 'https://sso-qa.nylservices.net', 'https://sso-stage.nylservices.net'],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  beforeSend: normalizeUnhandledRejectionEvent,
});

export default class Root extends Component {
  get content() {
    return (
      <Router>
        {this.props.routes}
      </Router>
    );
  }

  render() {
    return (
      <Provider store={this.props.store}>
        {this.content}
      </Provider>
    );
  }
}

Root.propTypes = {
  routes: PropTypes.element.isRequired,
  store: PropTypes.object.isRequired,
};
